
















import { Component, Prop, Vue } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { RootState } from '@/store/types'
import { EditorPage } from '@/store/ui/types'
import NPMPackage from '@/../package.json'
import SidePanelHeader from './SidePanelHeader.vue'
import SearchBox from './SearchBox.vue'
import SidePanelFooter from './SidePanelFooter.vue'
import VaultList from './vaults/VaultList.vue'

@Component({
    components: { VaultList, SidePanelHeader, SearchBox, SidePanelFooter },
    name: 'side-panel'
    })
export default class SidePanel extends Vue {
    version: string = NPMPackage.version

    devDismissed: boolean = false

    @State((state: RootState) => state.ui.page)
    page!: EditorPage
}
